import {useCallback, useEffect, useRef, useState} from 'react';

import {DataVisualization} from 'components/MediaDevicesDialog/AudioInputDevice';

type Props = {
    className?: string;
    audioStream: MediaStream;
    frameSizes: {width: number, height: number}
    fillStyle?: string
};

export const AudioStreamLinearBar: React.FC<Props> = ({
    audioStream, frameSizes, className, fillStyle = '#0047FF',
}) => {
    const analyser = useRef(null);
    const distortion = useRef(null);
    const [audioData, setAudioData] = useState(new Uint8Array(0));
    const requestAnimationFrameRef = useRef(0);

    const tick = useCallback(() => {
        const dataArray = new Uint8Array(analyser.current.frequencyBinCount);
        analyser.current.getByteTimeDomainData(dataArray);
        setAudioData(dataArray);
        requestAnimationFrameRef.current = requestAnimationFrame(tick);
    }, [analyser]);

    useEffect(() => {
        if (audioStream) {
            const audioContext = new window.AudioContext();
            analyser.current = audioContext.createAnalyser();
            analyser.current.fftSize = 64;
            const source = audioContext.createMediaStreamSource(audioStream);
            source.connect(analyser.current);
            distortion.current = audioContext.createWaveShaper();
            // commented to not have echo
            // analyser.current.connect(distortion.current);
            // distortion.current.connect(audioContext.destination);
            requestAnimationFrameRef.current = requestAnimationFrame(tick);
            return () => {
                cancelAnimationFrame(requestAnimationFrameRef.current);
                analyser.current.disconnect();
                distortion.current.disconnect();
                source.disconnect();
            };
        } else {
            return () => {
                cancelAnimationFrame(requestAnimationFrameRef.current);
            };
        }
    }, [audioStream, tick]);

    return (
        <DataVisualization className={className} audioData={audioData} frameSizes={frameSizes} fillStyle={fillStyle} />
    );
};